import React from 'react';
import { useJobSetupStore } from '@presentation/stores/JobSetupStore';
import { SvgIcon } from '@progress/kendo-react-common';
import * as svgIcons from '@progress/kendo-svg-icons';

export const ArchiveFileFormBlock: React.FC = () => {
    const archiveFiles = useJobSetupStore((state) => state.CreateJobState.archiveFiles || []);
    const setRightPanelTab = useJobSetupStore((state) => state.setRightPanelTab);
    const hasFiles = archiveFiles.length > 0;

    const getDisplayName = (path: string) => {
        const parts = path.split('/').filter(p => p.length > 0);
        if (parts.length === 0) return path;

        const lastPart = parts[parts.length - 1];

        // Check if it's the PulsarStep3 folder (which means the whole archive folder is selected)
        if (lastPart === 'PulsarStep3') {
            const rootPart = parts[0]; // Format: JobName_Timestamp (yyyyMMdd_HHmmss)
            // Remove timestamp _yyyyMMdd_HHmmss
            const jobName = rootPart.replace(/_\d{8}_\d{6}$/, '');
            return `${jobName} - Archives`;
        }

        return lastPart;
    };

    return (
        <fieldset className="k-form-fieldset">
            <legend className="k-form-legend">
                <strong>Archives</strong> <SvgIcon style={{ paddingBottom: '5px' }} icon={svgIcons.folderIcon} />
            </legend>

            <div style={{ marginBottom: '10px' }}>
                <div
                    style={{
                        border: hasFiles ? '1px solid #ccc' : '1px solid #ccc',
                        borderRadius: '3px',
                        padding: '8px',
                        minHeight: '32px',
                        backgroundColor: 'white',
                        display: 'flex',
                        alignItems: 'center',
                        flexWrap: 'wrap',
                        gap: '4px',
                        cursor: hasFiles ? 'default' : 'pointer',
                    }}
                    onClick={hasFiles ? undefined : () => setRightPanelTab(1)}
                    title={hasFiles ? undefined : 'Click to switch to the Archives tab'}
                >
                    {hasFiles ? (
                        archiveFiles.map((file, idx) => (
                            <span key={idx} style={{
                                backgroundColor: '#e3f2fd',
                                border: '1px solid #2196f3',
                                borderRadius: '3px',
                                padding: '2px 8px',
                                fontSize: '12px',
                                color: '#1976d2',
                            }}>
                                {getDisplayName(file.path)}
                            </span>
                        ))
                    ) : (
                        <span style={{ fontStyle: 'italic', fontSize: '13px', color: '#666' }}>
                            No archives selected (optional) — click here or switch to the <strong>Archives</strong> tab on the right.
                        </span>
                    )}
                </div>
            </div>
        </fieldset>
    );
};

